import { EscolaEditTabs, TipoPrograma } from "./__enum";

export interface Periodo {
  idEscola: number;
  periodo: string;
  edInfantilProf: number;
  edInfantilAlun: number;
  ensFundIProf: number;
  ensFundIAlun: number;
  ensFundIIProf: number;
  ensFundIIAlun: number;
  ensMedioProf: number;
  ensMedioAlun: number;
  ejaProf: number;
  ejaAlun: number;
  especializadaProf: number;
  especializadaAlun: number;
  colaboradores: number;
  permiteExclusao: boolean;
  permiteEdicao: boolean;
}

export interface ListaProps {
  id?: string;
  periodos: Periodo[];
  className?: string;
  paginaAtual: number;
  setPaginaAtual: (pagina: number) => void;
  totalPages: number;
  totalElements: number;
}

export interface ListaItemProps {
  id?: string;
  periodo: ListaItemPeriodo;
  desabilitarDuplicar: boolean;
  paginaAtual: number;
}

export interface ListaItemPeriodo {
  periodo: string;
  colaboradores?: number;
  permiteEdicao?: boolean;
  permiteExclusao?: boolean;
  [key: string]: any;
}

export interface AuthState {
  userPermissions: {
    escolas: {
      dadosDaEscola: {
        edit: boolean;
        remove: boolean;
      };
    };
  };
}
export interface SchoolEditParams {
  id: string;
  tab: EscolaEditTabs;
}
export interface ProgramasResponse {
  idPrograma: number;
  tipoPrograma: TipoPrograma;
  anoImplementacao: string;
  ativo: boolean;
}

export type Modo = 'cadastro' | 'edicao' | 'duplicar';

export const TITULOS: Record<Modo, string> = {
  edicao: 'Edição',
  cadastro: 'Cadastro',
  duplicar: 'Duplicação',
};
